// extracted by css-extract-rspack-plugin
export default {"cls1":"useFirstSuggestedWorkToast-cls1_o4s","cls2":"useFirstSuggestedWorkToast-cls2_yoi useFirstSuggestedWorkToast-cls1_o4s"};